var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState } from "react";
import { DatagridConfigurable, List, Button, TextField, FunctionField, NumberField, useListContext, useRecordContext, TextInput, SelectInput, useInput, } from "react-admin";
import { Box, ButtonBase, Chip, Typography } from "@mui/material";
import { LogRangeDateTimeInput } from "./logs/LogRangeDateTimeInput";
import { ListActions } from "@/components/ListActions";
import { useTranslation } from "react-i18next";
import { ChannelLabel, Dialog } from "@sequentech/ui-essentials";
import { AUDIT_ELECTORAL_LOG } from "@/queries/AuditElectoralLog";
import { useMutation } from "@apollo/client";
import { IPermissions } from "@/types/keycloak";
import { ResetFilters } from "./ResetFilters";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { useLogsPermissions } from "@/resources/ElectionEvent/useLogsPermissions";
import { MessageField } from "./MessageField";
import { ThreeStateDatagridHeader } from "./ThreeStateDatagridHeader";
import { electoralLogChannel } from "./electoralLogChannel";
import { useZonedFormat } from "@/hooks/useZonedFormat";
import { useContainerWidth } from "@/hooks/useContainerWidth";
import { ELECTORAL_LOG_DEFAULT_ZONE_FILTER, ELECTORAL_LOG_ZONE_FILTER, } from "@/queries/ListElectoralLog";
import { readinessDescription } from "./logs/readinessLog";
import { configurationPackageDescription } from "./logs/configurationPackageLog";
import { ballotLogDetails } from "./logs/ballotLogDetails";
import { logMessage } from "./logs/logMessage";
import { LogTime } from "./logs/LogTime";
import { ExportLogsDialog } from "./logs/ExportLogsDialog";
import { LogEntryDialog } from "./logs/LogEntryDialog";
import { useLogRowZone, useLogZones, useTenantLogZones } from "./logs/useLogZones";
import { TimeZonePicker } from "./timezones/TimeZonePicker";
import { LedgerStates, LedgerStatusField } from "./logs/LedgerStatus";
import { LOG_CHANNEL_NONE, LOG_FILTER_CHANNEL, LOG_FILTER_OUTCOME } from "./logs/messagingLogFilters";
import { ELogListLayout, ELogScope, LOG_EVENT_TYPES, LOG_FILTER_EVENT_TYPE, LOG_FILTER_LOG_TYPE, LOG_SCOPE_META, LOG_TYPES, TENANT_LOG_STATEMENT_KINDS, logListLayout, } from "./logs/logScope";
import { MESSAGE_ATTEMPT_STATES, MESSAGE_CHANNELS } from "@/types/messaging";
/** Columns that start hidden under Columns, whatever the width. */
var OMIT_FIELDS = ["user_id", "message"];
var LOG_TYPE_ERROR = "ERROR";
var ONE_LINE = {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
/** The shared range zone stays a react-admin filter, with the primary after reset. */
var LogTimeZoneFilter = function (_a) {
    var source = _a.source, label = _a.label, zones = _a.zones, primary = _a.primary;
    var field = useInput({ source: source }).field;
    return (_jsx(TimeZonePicker, { label: label, size: "small", sx: {
            width: { xs: "calc(100vw - 32px)", sm: 280 },
            maxWidth: "100%",
            minWidth: { xs: 0, sm: 260 },
            flexShrink: 0,
        }, value: field.value || primary, zones: zones, primary: primary, onChange: function (zone) { return field.onChange(zone); } }));
};
/** A row's Created or Statement Timestamp, in the row's log zone with my time below. */
var LogRowTime = function (_a) {
    var _b;
    var source = _a.source, zones = _a.zones, format = _a.format;
    var record = useRecordContext();
    var zoneOf = useLogRowZone(zones);
    return (_jsx(LogTime, { seconds: record === null || record === void 0 ? void 0 : record[source], zone: zoneOf((_b = logMessage(record)) === null || _b === void 0 ? void 0 : _b.election_id), format: format }));
};
var AuditDialog = function (_a) {
    var electionEventId = _a.electionEventId, open = _a.open, setOpen = _a.setOpen;
    var t = useTranslation().t;
    var auditElectoralLog = useMutation(AUDIT_ELECTORAL_LOG, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.ELECTORAL_LOG_AUDIT,
            },
        },
    })[0];
    var _b = useWidgetStore(), addWidget = _b[0], setWidgetTaskId = _b[1], updateWidgetFail = _b[2];
    var audit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, taskId, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.AUDIT_ELECTORAL_LOG, false);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, auditElectoralLog({
                            variables: { electionEventId: electionEventId },
                        })];
                case 2:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    taskId = (_b = data === null || data === void 0 ? void 0 : data.audit_electoral_log) === null || _b === void 0 ? void 0 : _b.task_execution.id;
                    if (errors || !taskId) {
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    setWidgetTaskId(currWidget.identifier, taskId);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Dialog, { variant: "info", open: open, ok: String(t("logsScreen.auditDialog.confirm")), cancel: String(t("common.label.cancel")), title: String(t("logsScreen.auditDialog.title")), handleClose: function (result) {
            setOpen(false);
            if (result) {
                audit();
            }
        }, children: _jsx("span", { children: t("logsScreen.auditDialog.description") }) }));
};
var headField = function (record, field) {
    var _a, _b, _c;
    var value = (_c = (_b = (_a = logMessage(record)) === null || _a === void 0 ? void 0 : _a.statement) === null || _b === void 0 ? void 0 : _b.head) === null || _c === void 0 ? void 0 : _c[field];
    return value ? String(value) : null;
};
var messageUser = function (record, field) {
    var _a;
    var value = (_a = logMessage(record)) === null || _a === void 0 ? void 0 : _a[field];
    if (value && value !== "null")
        return value;
    var projected = field === "username" ? record.username : null;
    return !projected || projected === "null" ? null : projected;
};
var description = function (t, record) {
    var _a, _b, _c, _d, _e;
    return (_b = (_a = readinessDescription(t, record.statement_kind)) !== null && _a !== void 0 ? _a : configurationPackageDescription(t, record.statement_kind, logMessage(record))) !== null && _b !== void 0 ? _b : (((_e = (_d = (_c = logMessage(record)) === null || _c === void 0 ? void 0 : _c.statement) === null || _d === void 0 ? void 0 : _d.head) === null || _e === void 0 ? void 0 : _e.description) || "-");
};
/** Use the timestamp's existing height; the description never adds another line to the row. */
var LogRowDescription = function (_a) {
    var _b, _c;
    var record = _a.record, zones = _a.zones, format = _a.format;
    var t = useTranslation().t;
    var zoneOf = useLogRowZone(zones);
    var seconds = (_b = record.statement_timestamp) !== null && _b !== void 0 ? _b : record.created;
    var hasMyTime = seconds !== null &&
        seconds !== undefined &&
        format.mine(seconds * 1000, zoneOf((_c = logMessage(record)) === null || _c === void 0 ? void 0 : _c.election_id)) !== null;
    var text = description(t, record);
    return (_jsx(Box, { component: "span", className: "log-description", title: text, sx: {
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: hasMyTime ? 2 : 1,
            overflow: "hidden",
            overflowWrap: "anywhere",
            whiteSpace: "normal",
        }, children: text }));
};
/** A narrow list's entry: two lines that open the same popup as a row. */
var CompactLogEntry = function (_a) {
    var _b, _c;
    var record = _a.record, zones = _a.zones, format = _a.format, onOpen = _a.onOpen;
    var t = useTranslation().t;
    var zoneOf = useLogRowZone(zones);
    var seconds = (_b = record.statement_timestamp) !== null && _b !== void 0 ? _b : record.created;
    var logType = headField(record, "log_type");
    return (_jsx(Box, { component: "li", className: "log-compact-entry", sx: { borderBottom: "1px solid", borderColor: "divider" }, children: _jsxs(ButtonBase, { onClick: function () { return onOpen(record); }, sx: { display: "block", width: "100%", textAlign: "start", px: 2, py: 1 }, children: [_jsx(Typography, { component: "span", variant: "body2", sx: __assign(__assign({}, ONE_LINE), { m: 0, color: "text.secondary" }), children: [
                        record.id,
                        seconds === null || seconds === undefined
                            ? null
                            : format.format(seconds * 1000, zoneOf((_c = logMessage(record)) === null || _c === void 0 ? void 0 : _c.election_id)),
                        messageUser(record, "username"),
                        record.statement_kind,
                        logType === LOG_TYPE_ERROR ? logType : null,
                    ]
                        .filter(function (part) { return part !== null && part !== undefined && part !== ""; })
                        .join(" · ") }), _jsx(Typography, { component: "span", variant: "body2", sx: __assign(__assign({}, ONE_LINE), { m: 0 }), children: description(t, record) })] }) }));
};
/** The page of a narrow list (a tablet held upright, a phone): two lines per entry. */
var CompactLogEntries = function (_a) {
    var zones = _a.zones, format = _a.format, onOpen = _a.onOpen;
    var t = useTranslation().t;
    var _b = useListContext(), data = _b.data, isPending = _b.isPending;
    if (isPending)
        return null;
    if (!(data === null || data === void 0 ? void 0 : data.length)) {
        return (_jsx(Typography, { variant: "body2", sx: { m: 0, p: 2 }, children: t("logsScreen.empty") }));
    }
    return (_jsx(Box, { component: "ul", className: "log-compact-list", sx: { listStyle: "none", m: 0, p: 0 }, children: data.map(function (record) { return (_jsx(CompactLogEntry, { record: record, zones: zones, format: format, onOpen: onOpen }, record.id)); }) }));
};
/** The popup of the entry that was clicked, in that entry's log zone. */
var OpenLogEntry = function (_a) {
    var _b;
    var entry = _a.entry, log = _a.log, zones = _a.zones, onClose = _a.onClose;
    var zoneOf = useLogRowZone(zones);
    return (_jsx(LogEntryDialog, { entry: entry, log: log, zone: zoneOf((_b = logMessage(entry)) === null || _b === void 0 ? void 0 : _b.election_id), onClose: onClose }));
};
export var ElectoralLogFilters;
(function (ElectoralLogFilters) {
    ElectoralLogFilters["ID"] = "id";
    ElectoralLogFilters["STATEMENT_KIND"] = "statement_kind";
    ElectoralLogFilters["USER_ID"] = "user_id";
    ElectoralLogFilters["USERNAME"] = "username";
})(ElectoralLogFilters || (ElectoralLogFilters = {}));
export var ElectoralLogList = function (_a) {
    var _b, _c;
    var aside = _a.aside, filterToShow = _a.filterToShow, filterValue = _a.filterValue, _d = _a.scope, scope = _d === void 0 ? ELogScope.EVENT : _d, electionEventId = _a.electionEventId, _e = _a.showActions, showActions = _e === void 0 ? true : _e;
    var record = useRecordContext();
    var t = useTranslation().t;
    var tenantLog = scope === ELogScope.TENANT;
    var eventId = tenantLog ? undefined : electionEventId || (record === null || record === void 0 ? void 0 : record.id) || undefined;
    var log = tenantLog
        ? { kind: ELogScope.TENANT }
        : { kind: ELogScope.EVENT, electionEventId: eventId !== null && eventId !== void 0 ? eventId : "" };
    var _f = useLogsPermissions(), canExportLogs = _f.canExportLogs, canAuditLogs = _f.canAuditLogs, canExportTenantLogs = _f.canExportTenantLogs, showLogsColumns = _f.showLogsColumns;
    // In the event's Logs tab the record is the event; elsewhere, the screen's event.
    var eventZones = useLogZones((record === null || record === void 0 ? void 0 : record.id) && record.id === eventId ? record : eventId);
    var tenantZones = useTenantLogZones(tenantLog);
    var zones = tenantLog ? tenantZones : eventZones;
    var format = useZonedFormat(zones.primary, { seconds: true });
    var _g = useState(false), openAudit = _g[0], setOpenAudit = _g[1];
    var _h = useState(false), openExport = _h[0], setOpenExport = _h[1];
    var _j = useState(null), entry = _j[0], setEntry = _j[1];
    var _k = useContainerWidth(), listRef = _k[0], width = _k[1];
    var layout = logListLayout(width);
    // Without a chosen zone, the range is read in the primary (also after a filter reset).
    var filterObject = __assign(__assign({}, (tenantLog ? {} : { election_event_id: eventId })), (_b = {}, _b[ELECTORAL_LOG_DEFAULT_ZONE_FILTER] = zones.primary, _b));
    if (filterToShow) {
        filterObject[filterToShow] = filterValue || undefined;
    }
    // Range filters hold wall times in the chosen zone; the data provider
    // turns them into instants.
    var filters = __spreadArray([
        _jsx(LogRangeDateTimeInput, { defaultZone: zones.primary, source: "created_from", label: String(t("logsScreen.filter.createdFrom")), alwaysOn: true }, "created_from"),
        _jsx(LogRangeDateTimeInput, { defaultZone: zones.primary, source: "created_to", label: String(t("logsScreen.filter.createdTo")), alwaysOn: true }, "created_to"),
        _jsx(LogTimeZoneFilter, { source: ELECTORAL_LOG_ZONE_FILTER, label: String(t("logsScreen.filter.timeZone")), zones: zones.choices, primary: zones.primary, alwaysOn: true }, ELECTORAL_LOG_ZONE_FILTER),
        _jsx(TextInput, { source: "user_id", label: String(t("logsScreen.column.user_id")) }, "user_id"),
        _jsx(TextInput, { source: "username", label: String(t("logsScreen.column.username")) }, "username"),
        _jsx(LogRangeDateTimeInput, { defaultZone: zones.primary, source: "statement_timestamp_from", label: String(t("logsScreen.filter.statementTimestampFrom")) }, "statement_timestamp_from"),
        _jsx(LogRangeDateTimeInput, { defaultZone: zones.primary, source: "statement_timestamp_to", label: String(t("logsScreen.filter.statementTimestampTo")) }, "statement_timestamp_to"),
        tenantLog ? (_jsx(SelectInput, { source: "statement_kind", label: String(t("logsScreen.column.statement_kind")), choices: TENANT_LOG_STATEMENT_KINDS.map(function (kind) { return ({ id: kind, name: kind }); }), translateChoice: false }, "statement_kind")) : (_jsx(TextInput, { source: "statement_kind", label: String(t("logsScreen.column.statement_kind")) }, "statement_kind")),
        _jsx(SelectInput, { source: LOG_FILTER_EVENT_TYPE, label: String(t("logsScreen.column.event_type")), choices: LOG_EVENT_TYPES.map(function (type) { return ({ id: type, name: type }); }), translateChoice: false }, LOG_FILTER_EVENT_TYPE),
        _jsx(SelectInput, { source: LOG_FILTER_LOG_TYPE, label: String(t("logsScreen.column.log_type")), choices: LOG_TYPES.map(function (type) { return ({ id: type, name: type }); }), translateChoice: false }, LOG_FILTER_LOG_TYPE)
    ], (tenantLog
        ? []
        : [
            _jsx(SelectInput, { source: LOG_FILTER_CHANNEL, label: String(t("messaging.logs.channel")), choices: __spreadArray(__spreadArray([], MESSAGE_CHANNELS.map(function (channel) { return ({
                    id: channel,
                    name: String(t("messaging.channel.".concat(channel))),
                }); }), true), [
                    {
                        id: LOG_CHANNEL_NONE,
                        name: String(t("messaging.reason.NO_CONTACT_CHANNEL")),
                    },
                ], false) }, LOG_FILTER_CHANNEL),
            _jsx(SelectInput, { source: LOG_FILTER_OUTCOME, label: String(t("messaging.logs.status")), choices: MESSAGE_ATTEMPT_STATES.map(function (state) { return ({
                    id: state,
                    name: String(t("messaging.state.".concat(state))),
                }); }) }, LOG_FILTER_OUTCOME),
        ]), true);
    // Each log, at each width, keeps its own choice of columns: Created
    // starts hidden where the list has no room for it.
    var preferenceKey = "electoral_log.".concat(scope, ".").concat(layout, ".datagrid");
    var omit = layout === ELogListLayout.WIDE ? OMIT_FIELDS : __spreadArray(__spreadArray([], OMIT_FIELDS, true), ["created"], false);
    var openEntry = function (row) { return setEntry(row); };
    var rows = layout === ELogListLayout.COMPACT ? (_jsx(CompactLogEntries, { zones: zones, format: format, onOpen: openEntry })) : (_jsxs(DatagridConfigurable, { preferenceKey: preferenceKey, header: ThreeStateDatagridHeader, omit: omit, bulkActionButtons: false, rowClick: function (_id, _resource, row) {
            openEntry(row);
            return false;
        }, sx: {
            "& .RaDatagrid-headerCell": { whiteSpace: "nowrap" },
            "& .RaDatagrid-rowCell": { verticalAlign: "top" },
            "& .column-description": { width: "100%", maxWidth: 0 },
        }, children: [_jsx(NumberField, { source: "id", label: String(t("logsScreen.column.id")) }), _jsx(FunctionField, { source: "user_id", label: String(t("logsScreen.column.user_id")), render: function (row) { var _a; return _jsx("span", { children: (_a = messageUser(row, "user_id")) !== null && _a !== void 0 ? _a : "-" }); } }), _jsx(FunctionField, { source: "username", label: String(t("logsScreen.column.username")), render: function (row) {
                    var _a;
                    return ballotLogDetails(logMessage(row)) ? (_jsx(Chip, { size: "small", label: messageUser(row, "username") })) : (_jsx("span", { children: (_a = messageUser(row, "username")) !== null && _a !== void 0 ? _a : "-" }));
                } }), _jsx(FunctionField, { source: "created", label: String(t("logsScreen.column.created")), render: function () { return _jsx(LogRowTime, { source: "created", zones: zones, format: format }); } }), _jsx(FunctionField, { source: "statement_timestamp", label: String(t("logsScreen.column.statement_timestamp")), render: function () { return (_jsx(LogRowTime, { source: "statement_timestamp", zones: zones, format: format })); } }), _jsx(TextField, { source: "statement_kind", label: String(t("logsScreen.column.statement_kind")) }), _jsx(FunctionField, { source: "event_type", label: String(t("logsScreen.column.event_type")), render: function (row) { var _a; return (_a = headField(row, "event_type")) !== null && _a !== void 0 ? _a : _jsx("span", { children: "-" }); } }), _jsx(FunctionField, { source: "log_type", label: String(t("logsScreen.column.log_type")), render: function (row) { var _a; return (_a = headField(row, "log_type")) !== null && _a !== void 0 ? _a : _jsx("span", { children: "-" }); } }), tenantLog ? null : (_jsx(FunctionField, { source: "channel", sortable: false, label: String(t("messaging.logs.channel")), render: function (row) {
                    var channel = electoralLogChannel(row.message);
                    return channel ? (_jsx(ChannelLabel, { channel: channel, label: t("messaging.channel.".concat(channel)) })) : (_jsx("span", { children: "-" }));
                } })), tenantLog ? null : (_jsx(FunctionField, { source: "status", sortable: false, label: String(t("messaging.logs.status")), render: function () { return _jsx(LedgerStatusField, {}); } })), _jsx(FunctionField, { source: "description", label: String(t("logsScreen.column.description")), render: function (row) { return (_jsx(LogRowDescription, { record: row, zones: zones, format: format })); } }), _jsx(FunctionField, { source: "message", sortable: false, label: String(t("logsScreen.column.message")), render: function () { return (
                // Show More opens the text in place, not the entry.
                _jsx(Box, { component: "span", onClick: function (event) { return event.stopPropagation(); }, children: _jsx(MessageField, { source: "message" }) })); } })] }, preferenceKey));
    return (_jsxs(Box, { ref: listRef, className: "electoral-log-list electoral-log-list-".concat(layout), sx: {
            "minWidth": 0,
            "& .RaList-main": { minWidth: 0 },
            "& .RaFilterForm-filterFormInput": { maxWidth: "100%", minWidth: 0 },
            "& .RaFilterForm-filterFormInput .MuiFormControl-root": {
                minWidth: 0,
                flexShrink: 1,
            },
            "& .RaFilterForm-filterFormInput input": { minWidth: 0 },
            // The filters and the buttons share one line while both fit;
            // the buttons move below when the list is narrower than both.
            "& .RaList-actions": { flexWrap: "wrap", alignItems: "flex-end", rowGap: 1 },
            "& .RaList-actions > form": { flex: "1 1 0", minWidth: "min(100%, 34rem)" },
            "& .RaList-actions > .list-actions": { marginLeft: "auto" },
            "& .RaList-actions .MuiToolbar-root": { flexWrap: "wrap", minHeight: 0 },
        }, children: [_jsxs(List, { resource: "electoral_log", actions: showActions && (_jsx(ListActions, { withColumns: layout !== ELogListLayout.COMPACT && (tenantLog || showLogsColumns), preferenceKey: preferenceKey, withImport: false, doExport: function () { return setOpenExport(true); }, withExport: tenantLog ? canExportTenantLogs : canExportLogs, withFilter: true, extraActions: canAuditLogs && eventId
                        ? [
                            _jsx(Button, { className: "audit-electoral-log", onClick: function () { return setOpenAudit(true); }, label: String(t("logsScreen.actions.audit")), children: _jsx(FactCheckIcon, {}) }, "audit"),
                        ]
                        : [] })), filters: filters, filter: filterObject, queryOptions: { meta: (_c = {}, _c[LOG_SCOPE_META] = scope, _c) }, storeKey: false, sort: {
                    field: "id",
                    order: "DESC",
                }, aside: aside, children: [_jsx(ResetFilters, { keepLinkedFilter: true }), _jsx(LedgerStates, { children: rows }), _jsx(OpenLogEntry, { entry: entry, log: log, zones: zones, onClose: function () { return setEntry(null); } })] }), _jsx(ExportLogsDialog, { log: log, open: openExport, onClose: function () { return setOpenExport(false); }, zones: zones.choices, byElection: zones.byElection }), eventId ? (_jsx(AuditDialog, { electionEventId: eventId, open: openAudit, setOpen: setOpenAudit })) : null] }));
};
